import React from 'react';
import { StepProps } from '../components/Step.component';
import { Size, getSizeLongName } from '../enums/size.enum';
import { calculateFitFromStepValues, calculateSizeFromStepValues } from '../utils/size-calculator';
import { Option } from '../models/option';
import { useRecoilValue } from 'recoil';
import { productsState } from '../../recoil/selectors';
import { useProductSelection } from '../../hooks/useProductSelection';
import { Button } from '../../root/components/buttons/Button';
import 'slick-carousel/slick/slick.css';
import styles from './FinalSizeViewRender.module.scss';

interface Props extends StepProps {
  onChange: (option: Option) => () => void;
  nextStepKey: string;
}

export const FinalSizeViewRender: React.FC<Props> = ({ onChange, nextStepKey, stepValues, productHandle, selectionType, selectionKey, onSizeSelect }) => {
  const { setSize, setFit } = useProductSelection(selectionType, selectionKey);
  const size = calculateSizeFromStepValues(stepValues, productHandle, false);
  const products = useRecoilValue(productsState);
  const fit = calculateFitFromStepValues(stepValues, products[productHandle]);

  const selectSize = (s: Size) => {
    const longSize = getSizeLongName(size);

    if (onSizeSelect) {
      onSizeSelect(longSize, fit, true);
      return;
    } else {
      longSize && setSize(longSize);
      fit && setFit(fit);
      onChange({
        text: Size[s],
        nextStepKey,
      })();
    }
  };

  return (
    <div className={styles.sizeViewRenderContainer}>
      <div className={styles.hlPerfectFitHeader}>Our recommendation</div>
      <div className={styles.hlWhiteOptionCard}>
        <div className={styles.hlPerfectFitTitle}>A perfect fit</div>
        <div className={styles.hlPerfectFitSize}>{Size[size]}</div>
        {fit && <div className={styles.hlPerfectFitTitle}>{fit}</div>}
        <Button onClick={() => selectSize(size)} text="Select this size" fullWidth={true} />
      </div>
    </div>
  );
};

export default FinalSizeViewRender;
